"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDesignerPalette = exports.FIELD_TYPE_DISPLAY = void 0;
var core_api_1 = require("@ikegps/core-api");
var icon_1 = require("../../components/icon");
var icons_1 = require("../../components/icon/icons");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var form_palette_style_1 = require("./form.palette.style");
(0, theme_1.addStyles)(form_palette_style_1.Style);
exports.FIELD_TYPE_DISPLAY = (_a = {},
    _a[core_api_1.IkeFieldType.TEXT] = { icon: icons_1.MaterialIcon.FIELD_TEXT, title: i18n_1.T.FIELD_TEXT },
    _a[core_api_1.IkeFieldType.HEIGHT] = { icon: icons_1.MaterialIcon.FIELD_HEIGHT, title: i18n_1.T.FIELD_HEIGHT },
    _a[core_api_1.IkeFieldType.NUMBER] = { icon: icons_1.MaterialIcon.FIELD_NUMBER, title: i18n_1.T.FIELD_NUMBER },
    _a[core_api_1.IkeFieldType.TRUE_SIZE] = { icon: icons_1.MaterialIcon.FIELD_TRUE_SIZE, title: i18n_1.T.FIELD_TRUE_SIZE },
    _a[core_api_1.IkeFieldType.DATE] = { icon: icons_1.MaterialIcon.FIELD_DATE, title: i18n_1.T.FIELD_DATE },
    _a[core_api_1.IkeFieldType.SELECT_LIST] = { icon: icons_1.MaterialIcon.FIELD_SELECT_LIST, title: i18n_1.T.FIELD_SELECT_LIST },
    _a[core_api_1.IkeFieldType.YES_NO] = { icon: icons_1.MaterialIcon.FIELD_YES_NO, title: i18n_1.T.FIELD_YES_NO },
    _a[core_api_1.IkeFieldType.NESTED_LIST] = { icon: icons_1.MaterialIcon.FIELD_NESTED_LIST, title: i18n_1.T.FIELD_NESTED_LIST },
    _a[core_api_1.IkeFieldType.FORM] = { icon: icons_1.MaterialIcon.FIELD_FORM, title: i18n_1.T.FIELD_FORM, maxDepth: 3 },
    _a[core_api_1.IkeFieldType.LOCATION] = { icon: icons_1.MaterialIcon.FIELD_LOCATION, title: i18n_1.T.FIELD_LOCATION },
    _a[core_api_1.IkeFieldType.IMAGE] = { icon: icons_1.MaterialIcon.FIELD_IMAGE, title: i18n_1.T.FIELD_IMAGE },
    _a[core_api_1.IkeFieldType.VECTOR] = { icon: icons_1.MaterialIcon.FIELD_VECTOR, title: i18n_1.T.FIELD_VECTOR },
    _a[core_api_1.IkeFieldType.ANCHOR] = { icon: icons_1.MaterialIcon.FIELD_ANCHOR, title: i18n_1.T.FIELD_ANCHOR },
    _a[core_api_1.IkeFieldType.VERTICAL_SEPARATION] = { icon: icons_1.MaterialIcon.VERTICAL_SEPARATION, title: i18n_1.T.FIELD_VERTICAL_SEPARATION },
    _a[core_api_1.IkeFieldType.FILE_TOOL] = { icon: icons_1.MaterialIcon.CLOUD_UPLOAD, title: i18n_1.T.FIELD_FILE_TOOL },
    _a);
exports.FormDesignerPalette = {
    viewPaletteIcon: function (fieldType) {
        return (0, mithril_1.m)('div', { className: "".concat(form_palette_style_1.CSS.field.container, " ").concat(form_palette_style_1.CSS.field.container, "--").concat(fieldType) }, [
            this.viewIcon(fieldType),
            this.viewTitle(fieldType)
        ]);
    },
    viewInline: function (fieldType) {
        return mithril_1.m.fragment({}, [
            this.viewIcon(fieldType),
            this.viewTitle(fieldType)
        ]);
    },
    viewIcon: function (fieldType, opts) {
        return icon_1.Icon.view(exports.FIELD_TYPE_DISPLAY[fieldType].icon, opts);
    },
    viewTitle: function (fieldType) {
        return (0, mithril_1.m)('div', { className: form_palette_style_1.CSS.field.title }, exports.FormDesignerPalette.translate(fieldType));
    },
    translate: function (fieldType) {
        return (0, i18n_1.Translate)(exports.FIELD_TYPE_DISPLAY[fieldType].title);
    },
    view: function (onclick, depth) {
        if (depth === void 0) { depth = 0; }
        var children = Object.keys(exports.FIELD_TYPE_DISPLAY)
            .filter(function (key) {
            var option = exports.FIELD_TYPE_DISPLAY[key];
            return services_1.Services.User.hasFormPermission(key) && !(option.maxDepth != null && option.maxDepth < depth);
        })
            .map(function (key) {
            var item = exports.FormDesignerPalette.viewPaletteIcon(key);
            item.attrs.onclick = function () {
                onclick(key);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:palette:add', key);
            };
            return item;
        });
        return (0, mithril_1.m)('div', { className: form_palette_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: form_palette_style_1.CSS.title }, (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_CHOOSE)),
            (0, mithril_1.m)('div', { className: form_palette_style_1.CSS.list.container }, children)
        ]);
    }
};
//# sourceMappingURL=form.palette.js.map